import type { frontendConfig } from '../back_end/ProjectConfig';

type ContentPipelineConfiguration = ReturnType<typeof frontendConfig>

export declare const configuration: ContentPipelineConfiguration;
export default {
	...configuration
};
